require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-ivo-trumpy.json") })
        }
      }, "path---en-interviste-ivo-trumpy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-ivo-trumpy!./.cache/json/en-interviste-ivo-trumpy.json
// module id = 585
// module chunks = 231608221292675